import axios from '../../../../axiosRetail';
import axiosLogin from '../../../../axiosLogin';
import axiosUpload from '../../../../axiosUpload';
import axiosAuthn from '../../../../axiosAuthen';
import axiosReleases from '../../../../axiosRetailReleases';

import { getListCategory, getListCategoryParent } from '../../../utils/Apis/Category/categoryApis';
import { getListUnitAxios, createUnitAxios } from '../../../utils/Apis/Unit/unitApis';
import { getListAgency as getListAgencyAxios } from '../../../utils/Apis/Agency/agencyApis';
import { getListResource as getListResourceAxios } from '../../../utils/Apis/Resource/resourceApis';
import { exportExcelFetching } from '../../../utils/fetchingData/fetchingDataDetail';

const uploadImage = (data, header) => {
    let bodyFormData = new FormData();
    bodyFormData.append('file', data);
    bodyFormData.append('username', 1);
    bodyFormData.append('file_type', 1);
    return axiosUpload({
        url: '/imedia/auth/media/upload_file',
        method: 'post',
        data: bodyFormData,
        headers: {},
    });
};

const exportExcel = async (data, headers) => {
    await exportExcelFetching(
        {
            url: '/product/excel',
            method: 'POST',
            headers,
            fileName: 'REPORT_PRODUCT_FORM',
            fileFormat: 'zip',
        },
        {
            data: data,
        }
    );
};

const exportExcelScaleValue = async (data, headers) => {
    await exportExcelFetching(
        {
            url: '/product/excel-scale-value',
            method: 'POST',
            headers,
            fileName: 'PRODUCT_SCALE_VALUE',
            fileFormat: 'zip',
        },
        {
            data: data,
        }
    );
};

const LoginController = (data, header) => {
    return axiosLogin({
        url: '/authenticate',
        method: 'POST',
        data: data,
        headers: header,
    });
};

const LoginAuthnController = (data, header) => {
    return axiosAuthn({
        url: '/public/login',
        method: 'POST',
        data: data,
        headers: header,
    });
};

// Product
const getListProduct = (data, header) => {
    return axios({
        url: '/product/list',
        method: 'POST',
        data: data,
        headers: header,
    });
};

const getDetailProduct = (id, header) => {
    return axios({
        url: '/product/detail',
        method: 'GET',
        params: {
            id: id,
        },
        headers: header,
    });
};

const getProductChangePrice = (data, header) => {
    return axios({
        url: '/product/change-price',
        method: 'POST',
        data: data,
        headers: header,
    });
};

const createProduct = (data, header) => {
    return axios({
        url: '/product/create',
        method: 'POST',
        data: data,
        headers: header,
    });
};
const updateProduct = (data, header) => {
    return axios({
        url: '/product/update',
        method: 'POST',
        data: data,
        headers: header,
    });
};

const deleteProduct = (data, header) => {
    return axios({
        url: '/product/delete',
        method: 'POST',
        data: data,
        headers: header,
    });
};

const getListCateGoryProduct = (data, header) => {
    return getListCategory(data, header);
};

const getListParentCateGoryProduct = (header, data = {}) => {
    return getListCategoryParent(header, data);
};

// Danh sach va don vi tinh co ban

const getListUnit = (data, header) => {
    return getListUnitAxios(data, header);
};

const createUnit = (data, header) => {
    return createUnitAxios(data, header);
};

const apiImportProduct = (data, header, listDataAgency, allAgency) => {
    const currentURL = window.location.href;
    const url = new URL(currentURL);
    const domain = url.origin;
    const link = url.pathname;

    let dataAgency = [];

    listDataAgency.map((agency, index) => {
        dataAgency.push({ groupIndex: index, agencyList: agency.value });
    });

    let bodyFormData = new FormData();
    bodyFormData.append('file', data);
    bodyFormData.append('allAgency', allAgency)
    bodyFormData.append('dataAgency', JSON.stringify(dataAgency));
    bodyFormData.append('link', link);
    bodyFormData.append('domain', domain);
    return axiosReleases({
        url: '/product/import',
        method: 'POST',
        responseType: 'blob',
        data: bodyFormData,
        headers: header,
    });
};

const apiDownloadFileTemplate = (header) => {
    return axios({
        url: '/product/download-file-template',
        method: 'GET',
        responseType: 'blob',
        headers: header,
    });
};

const apiNameFileTemplate = (header) => {
    return axios({
        url: '/product/name-file-template',
        method: 'GET',
        headers: header,
    });
};

const getListAgency = async (data, header) => {
    return getListAgencyAxios(data, header);
};

const getListResource = async (data, header) => {
    return getListResourceAxios(data, header);
};

const getListTypeChange = (header) => {
    return axios({
        url: '/product/list-type-change',
        method: 'GET',
        headers: header,
    });
};

// lay option loại sản phẩm
const getOptionsTypeProduct = async (header) => {
    return axios({
        url: '/product/list-select',
        method: 'GET',
        params: {
            type: 1,
        },
        headers: header,
    });
};

// lay option loại giao dịch
const getOptionsTypeTransaction = async (header) => {
    return axios({
        url: '/product/list-select',
        method: 'GET',
        params: {
            type: 2,
        },
        headers: header,
    });
};

// lay danh sách thẻ kho
const getListWarehouseCard = (data, header = {}) => {
    return axios({
        url: '/product/list-warehouse-card',
        method: 'POST',
        data: data,
        headers: header,
    });
};

// lay danh sach tồn kho
const getListInventory = (data, header = {}) => {
    return axios({
        url: '/product/list-inventory',
        method: 'POST',
        data: data,
        headers: header,
    });
};

// lấy danh sách lô và HSD
const getListProductPackage = (data, header = {}) => {
    return axios({
        url: '/product/list-product-package',
        method: 'POST',
        data: data,
        headers: header,
    });
};

// lấy trạng thái lô
const getListPackageStatus = (data, header = {}) => {
    return axios({
        url: '/package/list-droplist',
        method: 'GET',
        params: {
            type: 1,
        },
        headers: header,
    });
};

// xuất excel lô và HSD
const exportExcelProductPackage = async (data, headers = {}) => {
    await exportExcelFetching(
        {
            url: '/product/excel-product-package',
            method: 'POST',
            headers,
            fileName: 'REPORT_PRODUCT_PACKAGE_FORM_',
            fileFormat: 'zip',
        },
        {
            data: data,
        }
    );
};

// xuất excel thẻ kho
const exportExcelWarehouseCard = async (data, headers = {}) => {
    await exportExcelFetching(
        {
            url: '/product/excel-warehouse-card',
            method: 'POST',
            headers,
            fileName: 'REPORT_WAREHOUSE_CARD_',
            fileFormat: 'zip',
        },
        {
            data: data,
        }
    );
};

// /product/print-tem-xanh
const apiPrintTempGreen = (data) => {
    return axios({
        url: '/product/print-tem-xanh',
        method: 'POST',
        data: data,
    });
};


export {
    LoginController,
    getListProduct,
    getDetailProduct,
    exportExcel,
    deleteProduct,
    createProduct,
    getProductChangePrice,
    getListCateGoryProduct,
    getListParentCateGoryProduct,
    createUnit,
    getListUnit,
    updateProduct,
    uploadImage,
    apiImportProduct,
    apiDownloadFileTemplate,
    apiNameFileTemplate,
    getListAgency,
    getListResource,
    getListTypeChange,
    LoginAuthnController,
    getOptionsTypeProduct,
    getOptionsTypeTransaction,
    getListWarehouseCard,
    getListInventory,
    getListProductPackage,
    getListPackageStatus,
    exportExcelProductPackage,
    exportExcelWarehouseCard,
    exportExcelScaleValue,
    apiPrintTempGreen
};
